import { ExperienceSection } from '@components/sections/ExperienceSection/index'
import ThirdBlackHexagon from '@public/images/third-black-hexagon.svg'

import { config } from './config'
import { ExperienceSectionWrapper } from './styles'

export function DevOpsExperienceSection() {
  return (
    <ExperienceSectionWrapper>
      <ExperienceSection {...config} hexagon={<ThirdBlackHexagon />} hover />
    </ExperienceSectionWrapper>
  )
}
